/**
 * Builds initial params from input_schema.properties using the resolved values and
 * defaults. Only includes a key when its value is defined. input_image only when a value
 * resolves for it, never from a default. Then adds any allowed key (e.g. from allOf)
 * that resolves to a value but is not in properties.
 *
 * @param {Object} properties - input_schema.properties
 * @param {(key: string) => *} getValue - Resolves the current value for a canonical key
 * @param {string[]} topLevelRequired - input_schema.required
 * @param {Set<string>|string[]} allowedKeys - Every key the schema may emit
 */
export function buildInitialParams(properties, getValue, topLevelRequired, allowedKeys) {
  const required = new Set(topLevelRequired || [])
  const params = Object.entries(properties || {}).reduce((acc, [key, propSchema]) => {
    const resolvedValue = getValue(key)
    const value = resolvedValue !== undefined
      ? resolvedValue
      : propSchema?.default

    if (value === undefined || (key === 'input_image' && resolvedValue === undefined)) {
      return acc
    }

    acc[key] = value
    return acc
  }, {})

  const withRequired = Array.from(required).reduce((acc, key) => {
    if (acc[key] !== undefined) {
      return acc
    }

    const propSchema = properties?.[key]
    const defaultValue = propSchema?.default
    if (defaultValue !== undefined) {
      acc[key] = defaultValue
    }

    return acc
  }, { ...params })

  return Array.from(allowedKeys || []).reduce((acc, key) => {
    if (key in acc) {
      return acc
    }

    const resolvedValue = getValue(key)
    if (resolvedValue !== undefined) {
      acc[key] = resolvedValue
    }

    return acc
  }, { ...withRequired })
}
